function isRepeatActive(current, option) {
  const { times = -1, start = 0, duration, interval } = option;
  if (times === 0)
    return false;
  if (current < start)
    return false;
  const a = current - start;
  const b = duration + interval;
  if (times > 0 && Math.floor(a / b) >= times)
    return false;
  const remainder = a % b;
  return remainder < duration;
}
function getIntervalsFromRepeat(option) {
  return Array.from(generateIntervalsFromRepeat(option));
}
function* generateIntervalsFromRepeat(option) {
  let x = option.start ?? 0;
  let count = 0;
  while ((option.end == null || x + option.duration <= option.end) && (option.times == null || count < option.times)) {
    yield [x, x + option.duration];
    x += option.interval + option.duration;
    count++;
  }
}
export {
  generateIntervalsFromRepeat,
  getIntervalsFromRepeat,
  isRepeatActive
};
